import { all } from 'redux-saga/effects'

import adminSagas from './sagas/admin.saga'
import appSagas from './sagas/app.saga'
import authSagas from './sagas/auth.saga'
import bulkOrderSagas from './sagas/bulk-order.saga'
import chargeSagas from './sagas/charge.saga'
import chatRoomSaga from './sagas/chat-room.saga'
import consultationSagas from './sagas/consultation.saga'
import customDeviceSagas from './sagas/custom-device.saga'
import documentSagas from './sagas/document.saga'
import establishmentSagas from './sagas/establishment.saga'
import expertiseSagas from './sagas/expertise.saga'
import medecinSagas from './sagas/medecin.saga'
import meetingSagas from './sagas/meeting-link.saga'
import orderSagas from './sagas/order.saga'
import patientSagas from './sagas/patient.saga'
import rocketChatSagas from './sagas/rocket-chat.saga'
import roomSagas from './sagas/room.saga'
import socketSaga from './sagas/socket.saga'
import specialityOptionSaga from './sagas/speciality-option.saga'
import staffSagas from './sagas/staff.saga'
import statisticSagas from './sagas/statistic.saga'
import waitingRoomSagas from './sagas/waiting-room.saga'

export default function* rootSaga() {
  yield all([
    // add saga here
    ...adminSagas,
    ...appSagas,
    ...authSagas,
    ...bulkOrderSagas,
    ...chargeSagas,
    ...chatRoomSaga,
    ...consultationSagas,
    ...customDeviceSagas,
    ...documentSagas,
    ...establishmentSagas,
    ...expertiseSagas,
    ...medecinSagas,
    ...meetingSagas,
    ...orderSagas,
    ...patientSagas,
    ...rocketChatSagas,
    ...roomSagas,
    ...specialityOptionSaga,
    ...staffSagas,
    ...statisticSagas,
    ...waitingRoomSagas,
    socketSaga,
  ])
}
